import { h, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import ProductCard from 'utils/product-card';
import AngleRightIcon from 'utils/icon/icon-angle-right.svg';
import getRecommendedProducts from 'utils/nosto-recommendations';

const CartRecommendations = ({ title, placementId, layout }) => {
  const placements = [placementId];
  const [products, setProducts] = useState(null);
  const [defaultTitle, setDefaultTitle] = useState(null);

  useEffect(() => {
    const loadRecommendations = async () => {
      try {
        const res = await getRecommendedProducts(placements);
        if (res) {
          setProducts(res.products);
          setDefaultTitle(res.recommendations[placementId]?.title || null);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error loading recommendations:', error);
      }
    };

    loadRecommendations();
  }, []);

  return (
    <>
      {products?.[placementId] && (
        <div className="border-t border-grey-5 pb-40 pt-30">
          <h3 className="mb-20 pl-20 pr-88 text-primary">{title || defaultTitle}</h3>

          <div className="relative">
            {products[placementId]?.length > 1 && (
              <div className={`absolute  right-20 flex gap-6 ${title || defaultTitle ? '-top-[50px]' : '-top-[38px]'}`}>
                <button
                  data-arrow-left="cartRec"
                  className="arrow-circle swiper-button-disabled rotate-180  disabled:border-disabled disabled:text-disabled"
                >
                  <span className="sr-only">{window.TMW.Strings.accessibility.prevRec}</span>
                  <AngleRightIcon />
                </button>
                <button
                  data-arrow-right="cartRec"
                  className="arrow-circle swiper-button-disabled  disabled:border-disabled disabled:text-disabled"
                >
                  <span className="sr-only">{window.TMW.Strings.accessibility.nextRec}</span>
                  <AngleRightIcon />
                </button>
              </div>
            )}
            <Swiper
              modules={[Navigation]}
              slidesPerView={1.8}
              spaceBetween={12}
              navigation={{ nextEl: `[data-arrow-right="cartRec"]`, prevEl: `[data-arrow-left="cartRec"]` }}
              slidesOffsetBefore={15}
              slidesOffsetAfter={15}
              breakpoints={{
                1024: {
                  slidesOffsetBefore: 20,
                  slidesOffsetAfter: 20,
                },
              }}
            >
              {products[placementId]?.map((product) => (
                <SwiperSlide
                  key={product.id}
                  className="!flex min-h-24 items-center justify-center"
                >
                  <ProductCard
                    key={product.id}
                    product={product}
                    layout={layout}
                    template={'cart'}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}
    </>
  );
};

export default CartRecommendations;
